var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "item-con" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "el-tabs",
          {
            attrs: { "tab-position": "left" },
            on: { "tab-click": _vm.handleTabChange },
            model: {
              value: _vm.activeKey,
              callback: function ($$v) {
                _vm.activeKey = $$v
              },
              expression: "activeKey",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "饮片处方", name: "1" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "chmedForm",
                    attrs: {
                      model: _vm.pageData.activeDiagRecord.chmedPrescription,
                      "label-width": "80px",
                      size: "small",
                      inline: true,
                      disabled: _vm.isDisabled,
                    },
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("form-popup-item", {
                              attrs: {
                                "input-class-name": "treatment-input",
                                disabled: _vm.isDisabled,
                                code: "positionCode",
                                name: "药库编码",
                                url: "clinic/inventory/inventory/position",
                                "filed-list": [
                                  { code: "id", name: "ID" },
                                  { code: "code", name: "编码" },
                                  { code: "name", name: "名称" },
                                ],
                                "search-key": "name",
                                rules: _vm.chmedRules,
                                searcher: {
                                  storeCode: _vm.pageData.storeCode,
                                  positionSign: "1",
                                  classifySign: "3",
                                },
                              },
                              on: { onPopupClick: _vm.chmedPositionPopupClick },
                              model: {
                                value:
                                  _vm.pageData.activeDiagRecord
                                    .chmedPrescription.positionCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.pageData.activeDiagRecord
                                      .chmedPrescription,
                                    "positionCode",
                                    $$v
                                  )
                                },
                                expression:
                                  "pageData.activeDiagRecord.chmedPrescription.positionCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "药库名称" } },
                              [
                                _c("el-input", {
                                  staticClass: "treatment-input",
                                  attrs: { disabled: "" },
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .chmedPrescription.positionName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .chmedPrescription,
                                        "positionName",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.chmedPrescription.positionName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "加工方式" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "treatment-input",
                                    model: {
                                      value:
                                        _vm.pageData.activeDiagRecord
                                          .chmedPrescription.serveFeeSign,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.pageData.activeDiagRecord
                                            .chmedPrescription,
                                          "serveFeeSign",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "pageData.activeDiagRecord.chmedPrescription.serveFeeSign",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { value: "00", label: "不加工" },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "01", label: "代煎" },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "11", label: "制粒" },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "32", label: "蜜丸制丸" },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        value: "33",
                                        label: "大蜜丸制丸",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        value: "34",
                                        label: "浓缩丸制丸",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        value: "35",
                                        label: "水蜜丸制丸",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "41", label: "制瓶装膏" },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "42", label: "制袋装膏" },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "43", label: "制块装膏" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("form-popup-item", {
                              attrs: {
                                "input-class-name": "treatment-input",
                                disabled: _vm.isDisabled,
                                code: "decoctionName",
                                name: "煎法",
                                url: "clinic/clinicdic/clinicmedicinedic/clinicmeddic",
                                "filed-list": [
                                  { code: "medDictionaryCode", name: "编码" },
                                  { code: "medDictionaryName", name: "名称" },
                                ],
                                "search-key": "pinyinCode",
                                searcher: {
                                  storeCode: _vm.pageData.storeCode,
                                  medDirectoryCode: "JZ",
                                  effectiveSign: "1",
                                },
                              },
                              on: {
                                onPopupClick: _vm.chmedDecoctionPopupClick,
                              },
                              model: {
                                value:
                                  _vm.pageData.activeDiagRecord
                                    .chmedPrescription.decoctionName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.pageData.activeDiagRecord
                                      .chmedPrescription,
                                    "decoctionName",
                                    $$v
                                  )
                                },
                                expression:
                                  "pageData.activeDiagRecord.chmedPrescription.decoctionName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "总剂数" } },
                              [
                                _c("el-input-number", {
                                  staticClass: "treatment-input",
                                  attrs: { min: 1 },
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .chmedPrescription.doseNum,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .chmedPrescription,
                                        "doseNum",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.chmedPrescription.doseNum",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "次/日" } },
                              [
                                _c("el-input-number", {
                                  staticClass: "treatment-input",
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .chmedPrescription.dayDoseNum,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .chmedPrescription,
                                        "dayDoseNum",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.chmedPrescription.dayDoseNum",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "剂/日" } },
                              [
                                _c("el-input-number", {
                                  staticClass: "treatment-input",
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .chmedPrescription.dayFreq,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .chmedPrescription,
                                        "dayFreq",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.chmedPrescription.dayFreq",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("med-table", {
                  ref: "chmedTable",
                  attrs: {
                    "table-code": "chmedPrescriptionItemList",
                    disabled: _vm.isDisabled,
                  },
                }),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "中成药处方", name: "2" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "medForm",
                    attrs: {
                      model: _vm.pageData.activeDiagRecord.medPrescription,
                      "label-width": "120px",
                      size: "small",
                      inline: true,
                      disabled: _vm.isDisabled,
                    },
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("form-popup-item", {
                              attrs: {
                                "input-class-name": "treatment-input",
                                disabled: _vm.isDisabled,
                                code: "positionCode",
                                name: "药库编码",
                                url: "clinic/inventory/inventory/position",
                                "filed-list": [
                                  { code: "code", name: "编码" },
                                  { code: "name", name: "名称" },
                                ],
                                "search-key": "materielName",
                                rules: _vm.medRules,
                                searcher: {
                                  storeCode: _vm.pageData.storeCode,
                                  positionSign: "1",
                                  classifySign: "1",
                                },
                              },
                              on: { onPopupClick: _vm.medClincPopupClick },
                              model: {
                                value:
                                  _vm.pageData.activeDiagRecord.medPrescription
                                    .positionCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.pageData.activeDiagRecord
                                      .medPrescription,
                                    "positionCode",
                                    $$v
                                  )
                                },
                                expression:
                                  "pageData.activeDiagRecord.medPrescription.positionCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "药库名称" } },
                              [
                                _c("el-input", {
                                  staticClass: "w-full",
                                  attrs: { disabled: "" },
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .medPrescription.positionName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .medPrescription,
                                        "positionName",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.medPrescription.positionName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("med-table", {
                  ref: "medTable",
                  attrs: {
                    "table-code": "medPrescriptionItemList",
                    disabled: _vm.isDisabled,
                  },
                }),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "理疗安排", name: "3" } },
              [
                _c("med-table", {
                  ref: "serveTable",
                  attrs: {
                    "table-code": "servePrescriptionItemList",
                    disabled: _vm.isDisabled,
                  },
                }),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "代煎处方", name: "4" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "chmedForm",
                    attrs: {
                      model: _vm.pageData.activeDiagRecord.djPrescription,
                      "label-width": "80px",
                      size: "small",
                      inline: true,
                      disabled: _vm.isDisabled,
                    },
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("form-popup-item", {
                              attrs: {
                                "input-class-name": "treatment-input",
                                code: "pharmacyCode",
                                name: "药房编码",
                                url: "base/user/user/pharmacy",
                                "filed-list": [
                                  { code: "id", name: "ID" },
                                  { code: "code", name: "编码" },
                                  { code: "name", name: "名称" },
                                ],
                                "search-key": "name",
                                searcher: { storeCode: _vm.pageData.storeCode },
                              },
                              on: { onPopupClick: _vm.chmedPharmacyPopupClick },
                              model: {
                                value:
                                  _vm.pageData.activeDiagRecord.djPrescription
                                    .pharmacyCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.pageData.activeDiagRecord
                                      .djPrescription,
                                    "pharmacyCode",
                                    $$v
                                  )
                                },
                                expression:
                                  "pageData.activeDiagRecord.djPrescription.pharmacyCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "药房名称" } },
                              [
                                _c("el-input", {
                                  staticClass: "treatment-input",
                                  attrs: { disabled: "" },
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .djPrescription.pharmacyName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .djPrescription,
                                        "pharmacyName",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.djPrescription.pharmacyName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "加工方式" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "treatment-input",
                                    model: {
                                      value:
                                        _vm.pageData.activeDiagRecord
                                          .djPrescription.serveFeeSign,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.pageData.activeDiagRecord
                                            .djPrescription,
                                          "serveFeeSign",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "pageData.activeDiagRecord.djPrescription.serveFeeSign",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { value: "00", label: "不加工" },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "01", label: "代煎" },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "11", label: "制粒" },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "32", label: "蜜丸制丸" },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        value: "33",
                                        label: "大蜜丸制丸",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        value: "34",
                                        label: "浓缩丸制丸",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        value: "35",
                                        label: "水蜜丸制丸",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "41", label: "制瓶装膏" },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "42", label: "制袋装膏" },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: "43", label: "制块装膏" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "总剂数" } },
                              [
                                _c("el-input-number", {
                                  staticClass: "treatment-input",
                                  attrs: { min: 1 },
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .djPrescription.doseNum,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .djPrescription,
                                        "doseNum",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.djPrescription.doseNum",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "次/日" } },
                              [
                                _c("el-input-number", {
                                  staticClass: "treatment-input",
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .djPrescription.dayDoseNum,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .djPrescription,
                                        "dayDoseNum",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.djPrescription.dayDoseNum",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "剂/日" } },
                              [
                                _c("el-input-number", {
                                  staticClass: "treatment-input",
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .djPrescription.dayFreq,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .djPrescription,
                                        "dayFreq",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.djPrescription.dayFreq",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("med-table", {
                  ref: "djTable",
                  attrs: {
                    "table-code": "djPrescriptionItemList",
                    disabled: _vm.isDisabled,
                  },
                }),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "代售处方", name: "5" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "chmedForm",
                    attrs: {
                      model: _vm.pageData.activeDiagRecord.djPrescription,
                      "label-width": "80px",
                      size: "small",
                      inline: true,
                      disabled: _vm.isDisabled,
                    },
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("form-popup-item", {
                              attrs: {
                                "input-class-name": "treatment-input",
                                code: "pharmacyCode",
                                name: "药房编码",
                                url: "base/user/user/pharmacy",
                                "filed-list": [
                                  { code: "id", name: "ID" },
                                  { code: "code", name: "编码" },
                                  { code: "name", name: "名称" },
                                ],
                                "search-key": "name",
                                searcher: { storeCode: _vm.pageData.storeCode },
                              },
                              on: { onPopupClick: _vm.dsPharmacyPopupClick },
                              model: {
                                value:
                                  _vm.pageData.activeDiagRecord.dsPrescription
                                    .pharmacyCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.pageData.activeDiagRecord
                                      .dsPrescription,
                                    "pharmacyCode",
                                    $$v
                                  )
                                },
                                expression:
                                  "pageData.activeDiagRecord.dsPrescription.pharmacyCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "药房名称" } },
                              [
                                _c("el-input", {
                                  staticClass: "treatment-input",
                                  attrs: { disabled: "" },
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .dsPrescription.pharmacyName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .dsPrescription,
                                        "pharmacyName",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.dsPrescription.pharmacyName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("med-table", {
                  ref: "dsTable",
                  attrs: {
                    "table-code": "dsPrescriptionItemList",
                    disabled: _vm.isDisabled,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "label-con flex flex-row align-center" }, [
      _c("div", { staticClass: "icon" }),
      _c("div", { staticClass: "label" }, [_vm._v("治疗")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }